<template>
  <form :class="style['form-wrap']">
    <div :class="[style['input-text-box'], style['flex-horizontal']]" @click="openDatePicker">
      <div :class="style['input-icon-wrap']">
        <img :src="iconCalendar" alt="Icon calendar" />
      </div>
      <div :class="style['input-multiple']">
        <div v-theme-font :class="style['editable-highlight']">{{ startDate }}</div>
        <div>&mdash;</div>
        <div v-theme-font :class="style['editable-highlight']">{{ endDate }}</div>
      </div>
    </div>
    <div :class="[style['input-text-box'], style['flex-horizontal']]" @click="openPeopleSelector">
      <div :class="style['input-icon-wrap']">
        <img :src="iconPeople" alt="Icon people" />
      </div>
      <div :class="style['input-multiple']">
        <div>
          <span v-theme-font :class="style['editable-highlight']">{{ adults }}</span>
          <span>{{ adultText }}</span>
        </div>
        <div>
          <span v-theme-font :class="style['editable-highlight']">{{ children }}</span>
          <span>{{ childrenText }}</span>
        </div>
      </div>
    </div>
    <div :class="[style['input-text-box'], style['center']]" @click="openPeopleSelector">
      <span>{{ smoking }}</span>
    </div>
    <div v-if="error" class="error-text">
      <span>{{ error }}</span>
    </div>
    <div>
      <button
        v-theme
        :disabled="disabledSendBtn"
        :class="style['btn-pink']"
        type="button"
        @click="sendReservation()"
      >
        {{ search }}
      </button>
    </div>
  </form>
</template>

<script>
import { iconCalendar, iconPeople } from 'javascript/Constants'
import { formatDate, pluralize } from 'Utilities'
import { Chat } from 'src/apis'
import { EventBus } from 'ChatWidget/EventBus'
import style from './scss/_pages.scss'
import { useAppStore } from 'Store/app'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useDatepickerStore } from 'Store/datepicker'
import { useDetailsPageStore } from 'Store/details-page'

export default {
  setup() {
    return {
      appStore: useAppStore(),
      bottomPanelStore: useBottomPanelStore(),
      datepickerStore: useDatepickerStore(),
      detailsPageStore: useDetailsPageStore()
    }
  },

  data() {
    return {
      error: '',
      searchLoading: false,
      style
    }
  },
  computed: {
    messageRich() {
      const chat = this.detailsPageStore.chat
      return (chat && chat.message_rich) || {}
    },
    serverflowState() {
      return this.messageRich.state
    },
    disabledSendBtn() {
      return (
        !this.reservationFormStore.startDate ||
        !this.reservationFormStore.endDate ||
        this.searchLoading
      )
    },
    iconCalendar() {
      return iconCalendar
    },
    iconPeople() {
      return iconPeople
    },
    adults() {
      return this.reservationFormStore.adults
    },
    children() {
      return this.reservationFormStore.children
    },
    hotelName() {
      return this.reservationFormStore.hotelName || '--'
    },
    price() {
      return this.reservationFormStore.price || '--'
    },
    smoking() {
      if (this.reservationFormStore.smoking) {
        return this.$t('smoking')
      } else {
        return this.$t('no_smoking')
      }
    },
    startDate() {
      return this.reservationFormStore.startDate || '--'
    },
    endDate() {
      return this.reservationFormStore.endDate || '--'
    },
    search() {
      if (this.serverflowState === 'modify_booking') {
        return this.$t('confirm_form.search')
      } else {
        return this.$t('search')
      }
    },
    adultText() {
      const adultLocale = this.$t('adults')
      if (this.$i18n.locale === 'en') {
        return this.adults > 1 ? pluralize(adultLocale) : adultLocale
      } else {
        return adultLocale
      }
    },
    childrenText() {
      const childLocale = this.$t('children')
      if (this.$i18n.locale === 'en') {
        return this.children > 1 ? pluralize(childLocale) : childLocale
      } else {
        return childLocale
      }
    }
  },
  methods: {
    openDatePicker() {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const startDate = this.reservationFormStore.startDate || formatDate(new Date(), 'yyyy-MM-dd')
      const disabledDates = {
        to: today
      }
      this.datepickerStore.enableDateRange(true)
      this.bottomPanelStore.setBottomPanelInputFor('ReservationForm')
      this.datepickerStore.setDisabledDates(disabledDates)
      this.bottomPanelStore.setBottomPanelComponent('DatePickerPanel')
      this.datepickerStore.setTimeSettings({ currentDate: startDate })
    },
    openPeopleSelector() {
      this.bottomPanelStore.setBottomPanelInputFor('ReservationForm')
      this.bottomPanelStore.setBottomPanelComponent('PeopleSelector')
    },
    sendReservation() {
      if (this.searchLoading) return
      this.searchLoading = true
      EventBus.$emit('pageDisabledActionWidget')
      this.bottomPanelStore.setBottomPanelComponent()
      this.reservationFormStore.updateReservationFormPayload()
      const payload = this.reservationFormStore.payload
      const messageID = this.appStore.latestMessageID

      if (this.messageRich.use_send_message) {
        const options = {
          messageID: messageID,
          messageAction: JSON.stringify(payload)
        }
        payload.page = 'reservation_form'
        Chat.sendMessage(this.composeReply(payload), options)
        this.detailsPageStore.closeDetailsPageShown()
      } else {
        Chat.bestRoomAction('change_criteria', messageID, payload)
          .then(() => {
            this.detailsPageStore.closeDetailsPageShown()
            this.searchLoading = false
          })
          .catch((err) => {
            if (!(err instanceof Error) && typeof err === 'string') {
              this.error = err
            } else {
              this.error = this.$t('bad_connection')
            }
            this.searchLoading = false
          })
      }
    },
    composeReply(payload) {
      const replyArray = [
        `${payload.checkin_date} ~ ${payload.checkout_date}`,
        `${this.adultText}: ${payload.adults_number}`,
        `${this.childrenText}: ${payload.kids_number}`,
        this.smoking
      ]
      return replyArray.join('\n')
    }
  }
}
</script>
